import { Button } from "../styles";

export default function FetchError({ message, onRetry }) {
  return (
    <div className="my-4 text-center" role="alert">
      <p>{message}</p>
      <Button type="button" onClick={onRetry}>
        Spróbuj ponownie
      </Button>
    </div>
  );
}
